import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MdIcon extends Vue {
    @Prop()
    icon: string;
}
